export default "/images/type-underline.svg?4865d0c17fc5d0c9931726ac33f9e622";